import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { Link } from "react-router-dom";
import CustomText from "./customText.js";
import { Paginated } from "./paginate.js";
import {
  Grid,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  TextField,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2),
      backgroundColor: "#eee",
    },
  },
}));

const link = {
  textDecoration: "none",
  color: "black",
};
export default function AllRequestPagination(props) {
  const [defaultPage, setDefaultPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [perPage, setPerPage] = useState(15);
  const [allRequests, setAllRequests] = useState(
    Paginated(props.allRequests, 1, perPage).data
  );
  const [count, setCount] = useState(
    Paginated(props.allRequests, 1, perPage).total_pages
  );

  useEffect(() => {
    setAllRequests(Paginated(props.allRequests, 1, perPage).data);
    setCount(Paginated(props.allRequests, 1, perPage).total_pages);
    setSearchValue("");
  }, [props.allRequests]);
  const search = (value) => {
    const data = props.allRequests.filter((obj) => obj.crfNo.includes(value));
    const paginate = Paginated(data, 1, perPage);
    setAllRequests(paginate.data);
    setCount(paginate.total_pages);
    setPerPage(perPage);
    setSearchValue(value);
  };
  const classes = useStyles();
  return (
    <div>
      {allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 21)}</h4>
            </div>
            <div className="tData">
              {props.toggleReleased ? (
                <h4>{requestsArray.dateReleased}</h4>
              ) : (
                <h4 className="">
                  {requestsArray.expectedCompletionDate
                    ? requestsArray.expectedCompletionDate.slice(4, 21)
                    : "--"}
                </h4>
              )}
            </div>
            <div className="tData">
              <h4>{props.formatDate(requestsArray.dueDate)}</h4>
            </div>
            <div className="tData">
              <CustomText>{requestsArray.vendor.bpName}</CustomText>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
            <div className="tData">
              <CustomText>{requestsArray.project.projectName}</CustomText>
            </div>
            <div className="tData">
              <CustomText>{requestsArray.department.centerName}</CustomText>
            </div>
            <div className="tData">
              <h4>{requestsArray.status}</h4>
            </div>
          </div>
        </Link>
      ))}
      <div
        className={classes.root}
        style={{
          position: "fixed",
          bottom: "0",
          right: "0",
          width: "100%",
          paddingLeft: "260px",
          paddingBottom: "5px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <div>
              <InputLabel
                style={{
                  float: "left",
                  marginRight: "1rem",
                  marginTop: ".5rem",
                }}
              >
                Rows per page
              </InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                size="small"
              >
                <Select
                  labelId="label"
                  id="select"
                  defaultValue={perPage}
                  onChange={(e) => {
                    const paginate = Paginated(
                      props.allRequests,
                      1,
                      e.target.value
                    );
                    setAllRequests(paginate.data);
                    setCount(paginate.total_pages);
                    setPerPage(e.target.value);
                  }}
                  color="inherit"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
            <input
              size="14"
              placeholder="CRF# search..."
              value={searchValue}
              style={{
                marginTop: "-2.5rem",
                float: "right",
                padding: "12px",
                width: "125px",
              }}
              onChange={(e) => {
                search(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <Pagination
              count={count}
              defaultPage={defaultPage}
              color="default"
              style={{ float: "left" }}
              onChange={(e, value) => {
                const paginate = Paginated(props.allRequests, value, perPage);
                setAllRequests(paginate.data);
                setDefaultPage(value);
              }}
            />
            {props.grandTotal !== "0.00" ? (
              <div
                style={props.isCrfLoading? {display: "none"} :  {
                  float: "right",
                  marginRight: "1rem",
                  marginTop: ".5rem",
                  display: "contents"
                }}
              >
                <small>Total Amount: </small> &#8369; {props.grandTotal}
              </div>
            ) : null}
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
